module.exports = __webpack_public_path__ + "static/media/party.bb76e802.webp";